var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isIndexPage ? [_c('div', {
    class: ['mb-20', {
      'mb-sm-30 mb-lg-40': !_vm.deviceType.isMobile
    }]
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('components.sub.navigation.about-us'),
      "bordered": true,
      "back-button": {
        url: 'profile',
        hiddenAfterSizes: 'sm'
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    class: ['px-20 mb-20', {
      'px-md-30 mb-sm-30 mb-lg-40': !_vm.deviceType.isMobile
    }]
  }, [_c('div', {
    staticClass: "new-container mx-auto"
  }, [_c('station', {
    attrs: {
      "list": _vm.aboutUsMenu
    }
  })], 1)])] : [_c('div', [_c('nuxt-child')], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-mt-5 md:tw-mt-7.5 lg:tw-mt-10 tw-mb-5 md:tw-mb-7.5 lg:tw-mb-10"
  }, [_c('GetInTouch')], 1)]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }